import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "../../data/content";

const initials = (name) =>
  name.replace(/,.*$/, "").split(" ").slice(0, 2).map((w) => w[0]).join("");

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="bg-ink text-paper">
    <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-36">
      <Reveal className="max-w-3xl">
        <p className="overline text-terracotta">What people say</p>
        <h2 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight leading-[0.95]">
          In their words.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <figure
              data-testid={`testimonial-${i}`}
              className="h-full rounded-2xl border border-white/10 bg-white/[0.03] p-8 md:p-10"
            >
              <Quote size={28} className="text-terracotta" />
              <blockquote className="mt-5 font-serif text-xl md:text-2xl leading-[1.5] tracking-tight text-paper/90">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-4 border-t border-white/10 pt-6">
                <span className="grid place-items-center w-12 h-12 shrink-0 rounded-full bg-terracotta text-paper font-serif text-lg">
                  {initials(t.name)}
                </span>
                <div>
                  <p className="font-medium text-paper">{t.name}</p>
                  <p className="text-sm text-white/60">{t.title}</p>
                  <p className="mt-0.5 text-xs uppercase tracking-[0.14em] text-white/40">{t.context}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
